import { faUsers } from "@fortawesome/free-solid-svg-icons";
import { useTeam } from "@hooks";
import { useEffect } from "react";

import { DSDropdown } from "../../design-system/molecules";

const SelectTeam = ({
  currentTeam,
  setCurrentTeam,
  propHandleChange,
  dropdownWidth = "w-48",
}) => {
  const { userTeams } = useTeam();

  useEffect(() => {
    if (!currentTeam?.uuid && userTeams?.length) {
      setCurrentTeam(userTeams[0]);
    }
  }, [currentTeam, userTeams, setCurrentTeam]);

  if (!userTeams?.length || userTeams.length <= 1) {
    return null;
  }

  const handleChange = (value) => {
    const team = userTeams?.find((team) => team?.uuid === value);
    setCurrentTeam(team);
  };
  const handleSelectChange = propHandleChange || handleChange;

  return (
    <DSDropdown
      options={userTeams || []}
      value={currentTeam?.uuid || userTeams[0]?.uuid}
      onChange={handleSelectChange}
      getOptionLabel={(team) => team.name}
      getOptionValue={(team) => team.uuid}
      placeholder="Select team"
      searchPlaceholder="Search teams..."
      search
      width={dropdownWidth}
      leadingIcon={faUsers}
      dataTestId="select-team-dropdown"
    />
  );
};

export default SelectTeam;
